import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 36px;
  
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 32px;
    height: 36px;

    svg {
      cursor: pointer;

      &:hover path {
        fill: ${(props) => props.theme.colors.text};
        stroke: ${(props) => props.theme.colors.text};
      }
    }
    
    .badge {
      position: absolute;
      top: -2px;
      right: -2px;
      padding: 4px;
      border-radius: 50%;
      background: ${(props) => props.theme.colors.text};
    }
  }

`;

export default { Wrapper };
